import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";

export default function BasicTab() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="File Upload/Download"
            sx={{ textTransform: "none" }}
            component={Link}
            to="fileinterface"
          />

          {/* <Tab
            label="Quota File Generation"
            sx={{ textTransform: "none" }}
            component={Link}
            to="approval"
          /> */}
        </Tabs>
      </Box>
    </Box>
  );
}
